'use client';

import React from 'react';
import { Shield, Save, Eye } from 'lucide-react';
import { toast } from 'sonner';

export default function BrandVaultHeader() {
  return (
    <div className="flex items-start justify-between">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-accent/10 border border-accent/30 rounded flex items-center justify-center">
          <Shield size={20} className="text-accent" />
        </div>
        <div>
          <p className="section-label mb-0.5">Markenidentität</p>
          <h1 className="text-2xl font-800 text-white tracking-tight">Brand Vault</h1>
          <p className="text-sm text-muted mt-0.5">Berger GmbH · Zuletzt bearbeitet: <span className="mono text-accent">02.04.2026</span></p>
        </div>
      </div>
      <div className="flex gap-2">
        <button className="btn-ghost text-xs gap-2">
          <Eye size={13} />
          Vorschau
        </button>
        <button
          className="btn-primary text-xs"
          onClick={() => toast?.success('Brand Vault gespeichert', { description: 'Alle Marken-Einstellungen wurden aktualisiert.' })}
        >
          <Save size={13} />
          Speichern
        </button>
      </div>
    </div>
  );
}